var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.creditCard)?_c('ul',{staticClass:"uk-list"},[_c('li',[_vm._v(_vm._s(_vm.creditCard.description))]),_vm._v(" "),_c('li',[_vm._v(_vm._s(_vm.creditCard.token))])]):_vm._e()}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c68805a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./public/themes/frontend/uikit3/extensions/rubinred/ecommerce/assets/js/components/checkout/payment/CreditCardSummary.vue
// module id = GUHp
// module chunks = 0